export default __webpack_public_path__ + "static/media/card2.d7d37495.jpeg";